/**
 * KET Vocabulary - Home and Family Theme (93 words)
 */
import { KETWord } from './index';

export const homeFamilyWords: KETWord[] = [
  { word: 'house', meaning: '房子', example: 'We live in a big house.' },
  { word: 'home', meaning: '家', example: 'I go home after school.' },
  { word: 'apartment', meaning: '公寓', example: 'We live in an apartment.' },
  { word: 'flat', meaning: '公寓（英式）', example: 'Our flat is on the third floor.' },
  { word: 'room', meaning: '房间', example: 'My room is clean.' },
  { word: 'bedroom', meaning: '卧室', example: 'I sleep in my bedroom.' },
  { word: 'bathroom', meaning: '浴室', example: 'I wash my face in the bathroom.' },
  { word: 'kitchen', meaning: '厨房', example: 'Mom cooks in the kitchen.' },
  { word: 'living room', meaning: '客厅', example: 'We watch TV in the living room.' },
  { word: 'dining room', meaning: '餐厅', example: 'We eat in the dining room.' },
  { word: 'toilet', meaning: '厕所', example: 'The toilet is clean.' },
  { word: 'hall', meaning: '门厅', example: 'Leave your shoes in the hall.' },
  { word: 'stairs', meaning: '楼梯', example: 'The stairs are steep.' },
  { word: 'floor', meaning: '地板/楼层', example: 'My bedroom is on the second floor.' },
  { word: 'wall', meaning: '墙', example: 'There is a picture on the wall.' },
  { word: 'door', meaning: '门', example: 'Please close the door.' },
  { word: 'window', meaning: '窗户', example: 'Open the window, please.' },
  { word: 'ceiling', meaning: '天花板', example: 'The ceiling is high.' },
  { word: 'roof', meaning: '屋顶', example: 'The roof is red.' },
  { word: 'bed', meaning: '床', example: 'I sleep in my bed.' },
  { word: 'chair', meaning: '椅子', example: 'Please sit on the chair.' },
  { word: 'table', meaning: '桌子', example: 'The book is on the table.' },
  { word: 'desk', meaning: '书桌', example: 'I do homework at my desk.' },
  { word: 'sofa', meaning: '沙发', example: 'I sit on the sofa.' },
  { word: 'armchair', meaning: '扶手椅', example: 'Dad sits in the armchair.' },
  { word: 'bookcase', meaning: '书架', example: 'The books are in the bookcase.' },
  { word: 'wardrobe', meaning: '衣柜', example: 'My clothes are in the wardrobe.' },
  { word: 'cupboard', meaning: '橱柜', example: 'The cups are in the cupboard.' },
  { word: 'shelf', meaning: '架子', example: 'Put the book on the shelf.' },
  { word: 'lamp', meaning: '灯', example: 'Turn on the lamp.' },
  { word: 'mirror', meaning: '镜子', example: 'I look in the mirror.' },
  { word: 'carpet', meaning: '地毯', example: 'There is a carpet on the floor.' },
  { word: 'curtain', meaning: '窗帘', example: 'Close the curtains.' },
  { word: 'picture', meaning: '图画', example: 'There is a picture on the wall.' },
  { word: 'clock', meaning: '钟', example: 'The clock is on the wall.' },
  { word: 'telephone', meaning: '电话', example: 'The telephone is ringing.' },
  { word: 'phone', meaning: '电话', example: 'Can I use your phone?' },
  { word: 'television', meaning: '电视', example: 'I watch television in the evening.' },
  { word: 'TV', meaning: '电视', example: 'I like watching TV.' },
  { word: 'radio', meaning: '收音机', example: 'I listen to the radio.' },
  { word: 'computer', meaning: '电脑', example: 'I use the computer for homework.' },
  { word: 'fridge', meaning: '冰箱', example: 'The milk is in the fridge.' },
  { word: 'cooker', meaning: '炉灶', example: 'Mom uses the cooker to make dinner.' },
  { word: 'oven', meaning: '烤箱', example: 'The cake is in the oven.' },
  { word: 'washing machine', meaning: '洗衣机', example: 'The washing machine is new.' },
  { word: 'bath', meaning: '浴缸', example: 'I have a bath every day.' },
  { word: 'shower', meaning: '淋浴', example: 'I take a shower in the morning.' },
  { word: 'tap', meaning: '水龙头', example: 'Turn off the tap.' },
  { word: 'sink', meaning: '水槽', example: 'Wash your hands in the sink.' },
  { word: 'garden', meaning: '花园', example: 'We have a beautiful garden.' },
  { word: 'yard', meaning: '院子', example: 'The children play in the yard.' },
  { word: 'garage', meaning: '车库', example: 'Our car is in the garage.' },
  { word: 'gate', meaning: '大门', example: 'Please close the gate.' },
  { word: 'street', meaning: '街道', example: 'My house is on this street.' },
  { word: 'neighbour', meaning: '邻居', example: 'Our neighbours are friendly.' },
  { word: 'clean', meaning: '打扫', example: 'I clean my room.' },
  { word: 'tidy', meaning: '整理', example: 'Please tidy your room.' },
  { word: 'wash', meaning: '洗', example: 'I wash the dishes.' },
  { word: 'dry', meaning: '弄干', example: 'Dry your hands.' },
  { word: 'cook', meaning: '做饭', example: 'My mom can cook well.' },
  { word: 'sleep', meaning: '睡觉', example: 'I sleep in my bedroom.' },
  { word: 'eat', meaning: '吃', example: 'We eat dinner at 6pm.' },
  { word: 'drink', meaning: '喝', example: 'I drink water.' },
  { word: 'rest', meaning: '休息', example: 'I need a rest.' },
  { word: 'relax', meaning: '放松', example: 'I relax on the weekend.' },
  { word: 'in', meaning: '在...里面', example: 'The book is in the bag.' },
  { word: 'on', meaning: '在...上面', example: 'The pen is on the table.' },
  { word: 'under', meaning: '在...下面', example: 'The cat is under the table.' },
  { word: 'behind', meaning: '在...后面', example: 'The chair is behind the desk.' },
  { word: 'next to', meaning: '在...旁边', example: 'I sit next to my friend.' },
  { word: 'between', meaning: '在...之间', example: 'I sit between Tom and Mary.' },
  { word: 'big', meaning: '大的', example: 'We have a big house.' },
  { word: 'small', meaning: '小的', example: 'My room is small.' },
  { word: 'new', meaning: '新的', example: 'We have a new car.' },
  { word: 'old', meaning: '旧的', example: 'This is an old house.' },
  { word: 'beautiful', meaning: '美丽的', example: 'We have a beautiful garden.' },
  { word: 'comfortable', meaning: '舒适的', example: 'The sofa is comfortable.' },
  { word: 'quiet', meaning: '安静的', example: 'Our street is quiet.' },
  { word: 'noisy', meaning: '吵闹的', example: 'The street is noisy.' },
  { word: 'warm', meaning: '温暖的', example: 'The house is warm.' },
  { word: 'cold', meaning: '冷的', example: 'The room is cold.' },
  { word: 'dirty', meaning: '脏的', example: 'Your hands are dirty.' },
  { word: 'messy', meaning: '凌乱的', example: 'The room is messy.' },
  { word: 'pet', meaning: '宠物', example: 'I have a pet dog.' },
  { word: 'dog', meaning: '狗', example: 'My dog is cute.' },
  { word: 'cat', meaning: '猫', example: 'I have a cat.' },
  { word: 'live', meaning: '居住', example: 'I live in Beijing.' },
  { word: 'stay', meaning: '停留', example: 'I stay at home on Sundays.' },
  { word: 'move', meaning: '搬家', example: 'We are going to move to a new house.' },
  { word: 'towel', meaning: '毛巾', example: 'Dry your hands with a towel.' },
  { word: 'soap', meaning: '肥皂', example: 'Wash your hands with soap.' },
  { word: 'toothbrush', meaning: '牙刷', example: 'I use my toothbrush twice a day.' },
  { word: 'toothpaste', meaning: '牙膏', example: 'We need new toothpaste.' },
];